import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import { FaTimes } from "react-icons/fa";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { FLAG_CONFIG } from "variables";

const FlagDetailsDialog = ({ open, guest, onClose }) => {
  if (!guest?.flag?.type) return null;

  const config = FLAG_CONFIG[guest.flag.type];
  const Icon = config.icon;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <VuiBox display="flex" justifyContent="space-between" alignItems="center">
          <VuiBox display="flex" alignItems="center" gap={1}>
            <Icon size={18} color={config.color} />
            <VuiTypography variant="lg">{config.label}</VuiTypography>
          </VuiBox>

          <IconButton size="small" onClick={onClose}>
            <FaTimes color="#fff" />
          </IconButton>
        </VuiBox>

        <VuiTypography variant="caption" mt={0.5}>
          {guest.name}
          {guest.room ? ` · ${guest.room}` : ""}
        </VuiTypography>
      </DialogTitle>

      <DialogContent sx={{ p: 1, mt: 2 }}>
        <VuiBox
          p={2}
          borderRadius="12px"
          sx={{
            border: "1px solid rgba(255,255,255,0.15)",
            background: "rgba(255,255,255,0.03)",
          }}
        >
          <VuiTypography
            variant="caption"
            sx={{
              fontSize: "14px",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              whiteSpace: "pre-line",
            }}
          >
            {guest.flag.reason || "No details provided."}
          </VuiTypography>
        </VuiBox>
      </DialogContent>
    </Dialog>
  );
};

export default FlagDetailsDialog;
